import { useCallback, useRef, useState } from 'react'
import ModalCreateCustomer from '../../../../../../../app/erp/screens/Company/CustomerParent/AllCustomers/ModalCreateCustomer'
import LoadingSpinner from '../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../baseComponents/Modal/types'
import PermissionChecker from '../../../../../../../baseComponents/PermissionChecker'
import { InputTableURLsTable } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import TwinForm from '../../../../../../../forms/TwinForm'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import twinFetchPost from '../../../../../../../utils/globals/data'
import useEditDeleteModal from '../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'


interface ModalSendTicketTPVProps extends ModalSendTicketTPVLogicProps {
    url: string
    isReservedRefund?: boolean
    downloadPdfUrl?: string
}
const ModalSendTicketTPV: React.FC<ModalSendTicketTPVProps> = ({ setOpened, url, allRowData, inputTableURLs, OrderId, isReservedRefund, downloadPdfUrl }) => {
    const { t } = useTwinTranslation()
    const { loading, myOnSubmit, startLoading, openModal, setOpenModal, handleOnSubmitCreateCustomer, customerEmail } = useModalSendTicketTPVLogic({ setOpened, allRowData, inputTableURLs, OrderId })
    const CustomerId = allRowData?.headerData?.CustomerId
    const fields: FormRender<{ id: number, email: string, isReservedRefund?: number, WorkingCenterId: number}> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'email',
                    label: t('email', 'email'),
                    component: 'InputWithLabelMargin',
                    type: 'email',
                    required: true,
                    defaultValue: customerEmail || ''
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: OrderId
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: allRowData?.WorkingCenterId
                },
                {
                    name: 'isReservedRefund',
                    component: 'InputHidden',
                    value: isReservedRefund ? 1 : 0
                }
            ]
        }
    ]
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} onClickOut={false} className='modal_send_email flex_height'>
            <h2 className='text-center'><TwinTrans transKey='sendEmail'>Enviar email</TwinTrans></h2>
            <div className='my-30'><TwinTrans transKey='shoulAddAnEmailWhereSendReceipt'>Debes añadir el email al que quieras enviar el comprobante</TwinTrans></div>
            <TwinForm action={url} onSubmit={myOnSubmit} className='flex flex-auto flex-col justify-between gap-10' beforeSubmitHandler={startLoading} triggerErrors={false} triggerSuccess={false}>
                <FormRenderer sections={fields} />
                <div className='flex items-center'>
                    {!CustomerId ? <PermissionChecker userPermissions={getUserPermissions('customer.profile.main')} permission={'create'}><div className='cursor-pointer text-green-21' onClick={() => setOpenModal({ type: 'create', allRowData: {} })}><TwinTrans transKey='createNewCustomer'>Crear nuevo cliente</TwinTrans></div></PermissionChecker> : null}
                    {downloadPdfUrl ? <DownloadPdf downloadPdfUrl={downloadPdfUrl} OrderId={allRowData?.OrderId} full_assigned_number={allRowData?.headerData?.full_assigned_number} /> : null}
                </div>
                <div className='mt-20'>
                    <ButtonsModalSmallCentered confirmText={t('send', 'Enviar')} setOpened={() => {}} onCancel={() => setOpened(null)} loading={loading} />
                </div>
            </TwinForm>
            {openModal?.type === 'create' ? <ModalCreateCustomer setOpened={() => setOpenModal(null)} onSubmit={handleOnSubmitCreateCustomer} /> : null}
        </ModalSmallCentered>
    )
}

interface ModalSendTicketTPVLogicProps {
    setOpened: ModalOpenedSetTy
    allRowData: RowData
    inputTableURLs: InputTableURLsTable
    OrderId: number
}

const useModalSendTicketTPVLogic = ({ setOpened, allRowData, inputTableURLs, OrderId }: ModalSendTicketTPVLogicProps) => {
    const [customerEmail, setCustomerEmail] = useState<string | null>(allRowData?.headerData?.Customer?.email)
    const { openModal, setOpenModal } = useEditDeleteModal()
    const { startLoading, endLoading, loading } = useIsLoading()

    const myOnSubmit: OnSubmit = useCallback(async (res) => {
        if (res.status === 200) {
            setOpened(null)
        }
        endLoading?.()
    }, [endLoading, setOpened])

    const handleOnSubmitCreateCustomer: OnSubmit = useCallback(async (res: any) => {
        const result = await res.json()
        if (result) {
            if (result.email) {
                setCustomerEmail(result.email)
            }
            if (!allRowData?.headerData?.CustomerId) {
                const sellTicketId = allRowData?.headerData?.SellTicketId || OrderId
                await twinFetchPost(inputTableURLs.updateHeaderData, { id: sellTicketId, CustomerId: result.id})
                if (allRowData?.headerData?.SellTicketId) {
                    await twinFetchPost('/api/app/order/tpv/sellTicketRefund/updateSellTicketRefund', { id: OrderId, CustomerId: result.id})
                }
            }
            setOpenModal(null)
        }
    }, [setOpenModal, setCustomerEmail, inputTableURLs.updateHeaderData, allRowData, OrderId])

    return { loading, myOnSubmit, startLoading, openModal, setOpenModal, handleOnSubmitCreateCustomer, customerEmail }
}


interface DownloadPdfProps extends DownloadPdfLogicProps { }

const DownloadPdf: React.FC<DownloadPdfProps> = ({ ...logic }) => {
    const { loading, handleDownloadPdf, ref } = useDownloadPdfLogic({ ...logic })
    const { t } = useTwinTranslation()
    if (loading) {
        return <LoadingSpinner className='ml-auto'/>
    }
    return (
        <div ref={ref} className='ml-auto'>
            <div className='text-green-21 cursor-pointer' onClick={handleDownloadPdf}>{t('downloadPdf', 'Descargar PDF')}</div>
            <a className='hidden downloadfile' download={true} href='/' target='_blank' onClick={(e) => e.stopPropagation()}>a</a>
        </div>
    )
}

interface DownloadPdfLogicProps {
    downloadPdfUrl: string
    OrderId: number
    full_assigned_number: string
}

const useDownloadPdfLogic = ({ downloadPdfUrl, OrderId, full_assigned_number }: DownloadPdfLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const ref = useRef<any>(null)
    const handleDownloadPdf = useCallback(async () => {
        startLoading?.()
        const current = ref.current

        const result = await twinFetchPost(downloadPdfUrl, { id: OrderId })
        if (result) {
            const pdf = await result.blob()
            const fileURL = URL.createObjectURL(pdf)
            const a = current.querySelector('a')
            const fileName = full_assigned_number
            if (a) {
                a.href = fileURL
                a.download = fileName + '.pdf'
                a.click()
            }
            endLoading?.()
        }
        return result
    }, [startLoading, endLoading, full_assigned_number, OrderId, downloadPdfUrl, ref])

    return { loading, handleDownloadPdf, ref }
}

export default ModalSendTicketTPV